import { style } from '@vanilla-extract/css'

const footer = style({
  padding: '40px 24px 160px',
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  backgroundColor: '#252525',
})

const links = style({
  flexGrow: '1',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
})

const link = style({
  color: 'white',
  textDecoration: 'none',
  fontSize: '15px',
  lineHeight: '1.5',
})

const instagram = style({
  width: '56px',
  height: '56px',
})

export const styles = {
  footer,
  links,
  link,
  instagram,
}
